import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useMutation, useQueryClient } from "react-query";
import { changeUserPassword } from "../../services/security.service";
import { ApiResultModel, ShellConfig } from "../../models/common.model";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { Formik } from "formik";
import Paper from "@mui/material/Paper";
import { ChangePasswordRequest } from "../../models/security.model";
import Typography from "@mui/material/Typography";
import { Box, Button, Container, Grid } from "@mui/material";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { setForceChangePassword } from "../../services/auth.service";
import { GetUsers } from "../../services/chat.service";
import { GetUsersReponse } from "../../models/chat.model";
import { useSelector } from "react-redux";

interface Password {
  oldPassword: string | undefined;
  newPassword: string | undefined;
  repeatNewPassword: string | undefined;
}

const ForceToChangePassword = () => {
  let initialValues: Password = {
    oldPassword: "",
    newPassword: "",
    repeatNewPassword: "",
  };
  const history = useHistory();
  const queryClient = useQueryClient();
  const goToLogin = () => {
    history.push("/login");
  };
  const { mutate: GetUsersMutation } = useMutation(GetUsers, {
    onSuccess: (data: GetUsersReponse[]) => {
      if (data) {
        localStorage.setItem("getMentionusers", JSON.stringify(data));
      }
    },
    onError: () => {},
  });
  const { mutateAsync } = useMutation(changeUserPassword, {
    onSuccess: (data: ApiResultModel<boolean>) => {
      if (!data.isSuccess) {
        if (data.messages !== null && data.messages.length > 0) {
          toast.error(data.messages[0]);
        } else {
          toast.error("خطا در برقراری ارتباط با سرویس");
        }
      } else {
        GetUsersMutation();
        toast.success("رمز عبور با موفقیت تغییر یافت ");
        setForceChangePassword(String(false));
        history.push("/welcome");
      }
    },
    onError: () => {
      toast.error("خطا در برقراری ارتباط");
    },
  });

  const handleFormSubmit = async (values: any) => {
    let changePass = {} as ChangePasswordRequest;
    changePass.oldPassword = values.oldPassword!;
    changePass.newPassword = values.newPassword!;
    mutateAsync(changePass);
  };

  const passwordValidation = Yup.object().shape({
    newPassword: Yup.string()
      .ensure()
      .required("لطفا رمز عبور جدید را وارد نمایید.")
      .matches(/^(?=.*[a-z])/, "باید شامل یک حرف کوچک باشد")
      .matches(/^(?=.*[A-Z])/, "باید شامل یک حرف بزرگ باشد")
      .matches(/^(?=.*[0-9])/, "باید شامل یک عدد باشد.")
      .min(8, "رمز عبور باید حداقل 8 کاراکتر باشد"),
    repeatNewPassword: Yup.string()
      .ensure()
      .oneOf([Yup.ref("newPassword"), null], "با رمز عبور جدید یکسان نیست.")
      .required("لطفا رمز عبور جدید را مجددا تکرار نمایید."),
  });
  const jsonFile = useSelector((state: any) => state.style);

  return (
    <Container>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
        style={{ marginTop: "12vh", marginBottom: "8vh" }}
      >
        <Paper
          elevation={1}
          sx={{
            paddingY: "8rem",
            border: "2px solid lightgray",
            maxWidth: "650px",
          }}
        >
          <div style={{ width: "150px", height: "150px", margin: "0 auto" }}>
            <img
              src={jsonFile?.loginLogo}
              alt=" لگوی شرکت"
              style={{
                marginTop: "5vh",
                width: "100%",
                height: "auto",
                objectFit: "cover",
              }}
            />
          </div>
          <Typography className="iranSansMedium textCenter mTop50 fontWeight colorBase mbottom80 textFont20">
            تغییر رمز ورود
          </Typography>
          <Grid
            container
            spacing={0}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <Grid item xs={10}>
              <Formik
                initialValues={initialValues}
                onSubmit={handleFormSubmit}
                validateOnMount={true}
                validationSchema={passwordValidation}
              >
                {({
                  handleSubmit,
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid container justifyContent={"center"} spacing={2}>
                      <Grid item xs={12}>
                        {/* this input is for prevent autofill in Firefox */}
                        <input
                          value=""
                          name="prevent_autofill"
                          id="prevent_autofill"
                          type="password"
                          style={{ display: "none" }}
                        />
                        <MaterialTextFieldComponent
                          placeHolder={"رمز قبلی"}
                          label={"رمز قبلی"}
                          required={true}
                          name="oldPassword"
                          id="oldPassword"
                          autoFocus={true}
                          value={values.oldPassword}
                          onChange={handleChange}
                          type="password"
                          onKeyDown={(e) => {
                            if (
                              /^[آ-ی ء چ]+$/.test(e.key) &&
                              e.code !== "Space"
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          placeHolder={"رمز جدید"}
                          label={"رمز جدید"}
                          required={true}
                          name="newPassword"
                          id="newPassword"
                          helperText={
                            touched.newPassword ? errors.newPassword : ""
                          }
                          error={
                            touched.newPassword && Boolean(errors.newPassword)
                          }
                          onChange={handleChange}
                          value={values.newPassword}
                          onBlur={handleBlur}
                          type="password"
                          onKeyDown={(e) => {
                            if (
                              /^[آ-ی ء چ]+$/.test(e.key) &&
                              e.code !== "Space"
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          placeHolder={"تکرار رمز جدید"}
                          label={"تکرار رمز جدید"}
                          required={true}
                          name="repeatNewPassword"
                          id="repeatNewPassword"
                          helperText={
                            touched.repeatNewPassword ? errors.newPassword : ""
                          }
                          error={
                            touched.repeatNewPassword &&
                            Boolean(errors.newPassword)
                          }
                          onChange={handleChange}
                          value={values.repeatNewPassword}
                          onBlur={handleBlur}
                          type="password"
                          onKeyDown={(e) => {
                            if (
                              /^[آ-ی ء چ]+$/.test(e.key) &&
                              e.code !== "Space"
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Button
                          style={{ marginTop: "50px", marginBottom: "20px" }}
                          fullWidth
                          type="submit"
                          variant="contained"
                          disabled={
                            !values.repeatNewPassword ||
                            !values.newPassword ||
                            !values.oldPassword
                          }
                          className={
                            !values.repeatNewPassword ||
                            !values.newPassword ||
                            !values.oldPassword
                              ? "btnForm disabledBtn"
                              : "btnForm SuccessDefault"
                          }
                        >
                          تغییر رمز ورود
                        </Button>
                        <Typography
                          onClick={goToLogin}
                          className="SuccessDefaultFont textCenter mTop20 fontWeight cursorPointer textFont14"
                        >
                          <span className="colorBase">بازگشت به </span> ورود
                          حساب کاربری
                        </Typography>
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Container>
  );
};

export default ForceToChangePassword;
